/* eslint-disable global-require,import/no-unresolved, no-useless-concat,class-methods-use-this */
import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import { displayTelephoneLine } from '../methods/RegionalContentLookUp'

function getInBoxContent(t, locale) {
  if (displayTelephoneLine(locale)) {
    return (
      <BulletedListView testID="in-box-content" accesibilityLabel={t('access:inBoxContent')}>
        <Text style={textStyles.detailText}>{t('communicatorUnit')}</Text>
        <Text style={textStyles.detailText}>{t('adapter')}</Text>
        <Text style={textStyles.detailText}>{t('quickStartGuide')}</Text>
        <Text style={textStyles.detailText}>{t('patientManual')}</Text>
        <Text style={textStyles.detailText}>{t('phoneCord')}</Text>
      </BulletedListView>
    )
  }
  return (
    <BulletedListView testID="in-box-content" accesibilityLabel={t('access:inBoxContent')}>
      <Text style={textStyles.detailText}>{t('communicatorUnit')}</Text>
      <Text style={textStyles.detailText}>{t('adapter')}</Text>
      <Text style={textStyles.detailText}>{t('quickStartGuide')}</Text>
      <Text style={textStyles.detailText}>{t('patientManual')}</Text>
      <Text style={textStyles.detailText}>{t('phoneCord')}</Text>
      <Text testID="cell-adapter-item" style={textStyles.detailText}>{t('usbCellularAdapter')}</Text>
      <Text testID="usb-accessory-adapter-item" style={textStyles.detailText}>{t('usbAccessoryAdapter')}</Text>
    </BulletedListView>
  )
}

function getOptionalAccessoriesContent(t, locale) {
  if (displayTelephoneLine(locale)) {
    return (
      <BulletedListView testID="optional-accessories" headingText="" accesibilityLabel={t('access:optionalAccessoriesList')}>
        <Text testID="cell-adapter-item" style={textStyles.detailText}>{t('usbCellularAdapter')}</Text>
        <Text testID="ethernet-adapter-item" style={textStyles.detailText}>{t('usbEthernetAdapter')}</Text>
        <Text testID="usb-accessory-adapter-item" style={textStyles.detailText}>{t('usbAccessoryAdapter')}</Text>
      </BulletedListView>
    )
  }
  return (
    <BulletedListView testID="optional-accessories" headingText="" accesibilityLabel={t('access:optionalAccessoriesList')}>
      <Text testID="ethernet-adapter-item" style={textStyles.detailText}>{t('usbEthernetAdapter')}</Text>
    </BulletedListView>
  )
}

function WhatsInMonitorBoxPage(props) {
  const { t, locale } = props
  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        style={{ backgroundColor: colors.white }}
        testID="scrollview-WhatsInTheBox"
      >
        <View style={styles.stepsContainer}>
          <Text style={[textStyles.h1, styles.shark_grey]}>{t('whatsInBoxTitle')}</Text>
        </View>
        <View style={{ padding: 16 }}>
          <Text style={styles.monitorHeading}>{t('itemsIncluded')}</Text>
          <View>
            {getInBoxContent(t, locale)}
          </View>
        </View>
        <View style={{ padding: 16 }}>
          <Text style={styles.monitorHeading}>
            {t('optionalAccessories')}
          </Text>
          <View>
            {getOptionalAccessoriesContent(t, locale)}
          </View>
        </View>
      </ScrollView>
    </View>
  )
}

WhatsInMonitorBoxPage.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string,
}

WhatsInMonitorBoxPage.defaultProps = {
  locale: 'en_US',
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return { locale: storedData.locale }
}

export const WhatsInMonitorBoxPageComponent = WhatsInMonitorBoxPage

export default withTranslation(['whatsInBox'])(connect(mapStateToProps, null)(WhatsInMonitorBoxPage))
